module.exports = __webpack_public_path__ + "img/ndtimer.5667bc51.png";